import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';
import type * as Types from './types';

interface IState {
    readonly isLoading: boolean;
    readonly isUpdating: boolean;
    readonly showAdvanced: boolean;
    readonly invoiceSettings: Types.InvoiceSettings | null;
}

class State extends Record<IState>({
    isLoading: true,
    isUpdating: false,
    showAdvanced: false,
    invoiceSettings: null,
}) {}

class InvoiceSettings extends Record<Types.InvoiceSettings>({
    header: '',
    footer: '',
    pageFooter: '',
    greeting: '',
    directDebitFooter: '',
    logo: null,
    hideHours: false,
    detailedActuals: false,
    detailedAnnualized: false,
    showBalanceInEmails: false,
    showDetailedTransactions: false,
    showZeroVat: false,
    costCenter: '',
    organizationNo: '',
    imageId: null,
}) {}

class InvoiceLogo extends Record<Types.InvoiceLogo>({
    imageId: '',
    url: '',
}) {}

export default makeReducer<State>(
    [
        match(Actions.toggleAdvanced, (state, {payload}) =>
            state.merge({
                showAdvanced: payload.show,
            }),
        ),

        match(Actions.updateInvoiceSettings, state =>
            state.merge({
                isUpdating: true,
            }),
        ),

        match(Actions.updateInvoiceSettingsSuccess, state =>
            state.merge({
                isUpdating: false,
            }),
        ),

        match(Actions.updateInvoiceSettingsFailed, state =>
            state.merge({
                isUpdating: false,
            }),
        ),

        match(Actions.fetchInvoiceSettingsSuccess, (state, {payload}) =>
            state.merge({
                isLoading: false,
                invoiceSettings: new InvoiceSettings({
                    ...payload.invoiceSettings,
                    logo: payload.invoiceSettings.logo ? new InvoiceLogo(payload.invoiceSettings.logo) : null,
                }),
            }),
        ),
        match(Actions.fetchInvoiceSettings, () => new State()),
        match(Actions.fetchInvoiceSettingsFailed, state => state.merge({isLoading: false})),
    ],
    new State(),
);
